<template>
  <div v-if="permission != 'n'">
    <viewer :images="imgArr" :options="options" v-model="inputVal">
      <ul>
        <li v-for="(item, index) of imgArr" :key="index">
          <el-card
            alt="查看原图"
            :body-style="{ padding: '0px', margin: '10px', cursor: 'pointer' }"
          >
            <img :src="item.url" :key="index" :style="style" />
            <div  v-if="permission != 'r'">
              <span>{{ item.fileName }}</span>
              <el-row style="float: right; padding: 3px 0">
                <el-button
                  v-if="uploadType == 'local'"
                  icon="el-icon-download"
                  circle
                  @click="downloadFile(item)"
                ></el-button>
                <el-button
                 
                  icon="el-icon-delete"
                  circle
                  @click="imgArr.remove(item)"
                ></el-button>
              </el-row>
            </div>
          </el-card>
        </li>
      </ul>
    </viewer>
    <el-upload
      v-if="uploadType == 'local' && permission != 'r'"
      class="upload-demo"
      :action="actionUrl"
      :headers="header"
      :file-list="imgArr"
      :show-file-list="false"
      :on-success="success"
      :on-progress="progress"
      :before-upload="beforeAvatarUpload"
      :multiple="multiple"
      :limit="Number(limit)"
      :on-exceed="handleExceed"
    >
      <el-tooltip placement="right" effect="light">
        <div slot="content">附件格式支持：img/jpg/gif</div>
        <el-button size="mini" round icon="el-icon-plus">上传</el-button>
      </el-tooltip>
    </el-upload>
    <el-button
      v-if="uploadType == 'https' && permission != 'r'"
      size="mini"
      round
      icon="el-icon-plus"
      @click="dialogFormVisible = true"
      >上传</el-button
    >

    <el-dialog title="网络图片上传" :visible.sync="dialogFormVisible">
      <el-form :model="httpsFile" data-vv-scope="httpsFileForm">
        <el-form-item label="文件名称" label-width="100px">
          <ht-input
            placeholder="请输入文件名称"
            v-model="httpsFile.fileName"
            :validate="{ required: true }"
          ></ht-input>
        </el-form-item>
        <el-form-item label="文件地址" label-width="100px">
          <ht-input
            placeholder="请输入文件地址"
            v-model="httpsFile.url"
            :validate="{ required: true }"
          ></ht-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="httpsDialog()">确定</el-button>
        <el-button @click="dialogFormVisible = false">{{
          $t("eip.common.cancel")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import req from "@/request.js";
import { mapState } from "vuex";
import { Loading } from "element-ui";
import hotentUtils from "@/hotent-ui-util.js";
export default {
  name: "EipViewer",
  props: [
    "value",
    "permission",
    "modelExpression",
    "imgHeight",
    "imgWidth",
    "uploadType",
    "limit",
    "multiple",
  ],
  data() {
    return {
      httpsFile: { fileName: "", url: "" },
      dialogFormVisible: false,
      style: {
        width: "265px",
        height: "180px",
        border: "2px solid #ccc",
        borderRadius: "3px",
        padding: "1px",
        margin: "1px",
        cursor: "pointer"
      },
      imgArr: [],
      options: {
        inline: false,
        button: true,
        navbar: true,
        title: false,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: "data-source"
      }
    };
  },
  computed: mapState({
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    header: state => {
      return { Authorization: `Bearer ${state.login.currentUser.token}` };
    },
    actionUrl: function() {
      return req.getContext().portal + "/system/file/v1/upload";
    }
  }),
  watch: {
    imgArr: function(newVal) {
      if (newVal) {
        this.$emit("input", JSON.stringify(this.imgArr));
      }
    }
  },
  mounted() {
    if (this.value) {
      let ary = JSON.parse(this.value);
      if(ary instanceof Array){
        this.imgArr = ary;
      }
    }
    if (this.imgHeight > 0 && this.imgWidth > 0) {
      this.style = {
        height: this.imgHeight + "px",
        width: this.imgWidth + "px"
      };
    }
  },
  created() {
    this.$validator = this.$root.$validator;
  },
  methods: {
    handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 ${Number(this.limit)} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
    progress() {
      Loading.service("文件上传中");
    },
    //文件上传成功时
    success(response, file, fileList) {
      let loadingInstance = Loading.service("文件上传中");
      const this_ =this;
      setTimeout(function () {
        if(fileList.length != this_.imgArr.length){
          for (let i = 0; i < fileList.length; i++) {
            let value = fileList[i].response;
            if (value) {
              let item = {};
              item.url =
                      req.getContext().portal +
                      "/system/file/v1/downloadFile?fileId=" +
                      value.fileId;
              item.fileName = value.fileName;
              this_.imgArr.push(item);
            }
          }
        }
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      }, 1000);
    },
    beforeAvatarUpload(file) {
      var FileExt = file.name.replace(/.+\./, "");
      if (
        ["jpg", "png", "gif", "ico", "jpeg"].indexOf(FileExt.toLowerCase()) ===
        -1
      ) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为jpg、png、gif、ico、jpeg类型的图片"
        });
        return false;
      }
    },
    downloadFile(item) {
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = item.fileName; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = item.url;
    },
    httpsDialog: function() {
      this.$validator.validateAll("httpsFileForm").then(result => {
        if (result) {
          let item = {
            fileName: this.httpsFile.fileName,
            url: this.httpsFile.url
          };
          this.imgArr.push(item);
          this.httpsFile = { fileName: "", url: "" };
          this.dialogFormVisible = false;
        } else {
          this.$message.error("表单未正确填写");
        }
      });
    }
  }
};
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
ul {
  display: flex;
  flex-wrap: wrap;
}
ul li {
  list-style: none;
}
</style>
